export default function WhatIsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-6 text-center">
          Czym jest Kakobuy Spreadsheet?
        </h2>
        <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8 max-w-2xl mx-auto text-center">
          Kakobuy Spreadsheet to uporządkowana baza produktów zawierająca najlepsze znaleziska zakupowe,
          linki, kategorie oraz informacje pomagające użytkownikom szybciej znaleźć interesujące produkty.
          Zamiast godzinami szukać pojedynczych ofert, użytkownicy mogą korzystać z gotowych list
          produktów przygotowanych według kategorii.
        </p>

        <div className="overflow-x-auto">
          <table className="w-full max-w-2xl mx-auto border-collapse">
            <thead>
              <tr className="border-b border-background-300/60">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-950">Funkcja</th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-600">Normalne wyszukiwanie</th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-primary-500">Kakobuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70">
                <td className="py-3 px-4 text-sm text-foreground-700">Znalezienie produktu</td>
                <td className="text-center py-3 px-4 text-sm text-foreground-500">Trudne</td>
                <td className="text-center py-3 px-4 text-sm text-primary-600 font-medium">Kilka sekund</td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-3 px-4 text-sm text-foreground-700">Organizacja linków</td>
                <td className="text-center py-3 px-4 text-sm text-foreground-500">Brak</td>
                <td className="text-center py-3 px-4 text-sm text-primary-600 font-medium">Gotowe listy</td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-3 px-4 text-sm text-foreground-700">Porównanie produktów</td>
                <td className="text-center py-3 px-4 text-sm text-foreground-500">Ręczne</td>
                <td className="text-center py-3 px-4 text-sm text-primary-600 font-medium">Szybkie</td>
              </tr>
              <tr>
                <td className="py-3 px-4 text-sm text-foreground-700">Oszczędność czasu</td>
                <td className="text-center py-3 px-4 text-sm text-foreground-500">Niska</td>
                <td className="text-center py-3 px-4 text-sm text-primary-600 font-medium">Wysoka</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}